/**
 * types.ts
 */

/**
 * Selects which animation preset Animator applies. Exposed as a static
 * property (`Animator.Type`) so callers only need one import.
 */
export enum AnimatorType {
  CHANNELS_CHOICE,
  CHANNELS_LINEUP,
  DETAIL,
  GRID,
  RAILS,
  SEARCH,
  SETTING,
}

export interface AxisPreset {
  offset: {
    EXPANDED: number;
    COLLAPSED: number;
  };
  duration?: number;
  delay?: number;
  easing?: string;
  extraTransition?: string;
  style?: React.CSSProperties;
}

export interface TypeConfig {
  horizontal?: AxisPreset;
  vertical?: AxisPreset;
  style?: React.CSSProperties;
}

export interface AnimatorProps {
  type?: AnimatorType;
  collapse?: {
    horizontal?: boolean;
    vertical?: boolean;
  };
  containerProps?: {
    horizontal?: React.HTMLAttributes<HTMLDivElement>;
    vertical?: React.HTMLAttributes<HTMLDivElement>;
  };
  [key: string]: unknown;
}
